import { render, staticRenderFns } from "./UtilizationStatusCrud.vue?vue&type=template&id=0ca375eb&"
import script from "./UtilizationStatusCrud.vue?vue&type=script&lang=js&"
export * from "./UtilizationStatusCrud.vue?vue&type=script&lang=js&"
import style0 from "./UtilizationStatusCrud.vue?vue&type=style&index=0&id=0ca375eb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports